import React, { useState, useEffect } from 'react';
import AddOnOverlayHeader from './AddonOverlayHeader';
import AddOnOverlayBody from './AddonOverlayBody';
import Loader from './AddonOverlayLoader';
import holidayService from '../../../../../../../../common/service/holidayService';

import './style.scss';

const AddOnInfoOverlay = ({ closeOverlay, onTncClick }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await holidayService.post('/addon/static/detail', {
        addonSubType: 'VISA_PROTECTION_PLAN',
        addonType: 'TRIP_MONEY',
        sections: ['BENEFITS', 'WORKFLOW', 'CONSUMERS_GUIDE'],
      });
      if (response?.data?.success) {
        setData(response?.data?.addonStaticDetails);
      } else {
        setError('Failed to fetch data');
      }
    } catch (error) {
      setError('Failed to fetch data');
    } finally {
      setLoading(false);
    }
  };

  const handleBackClick = () => {
    closeOverlay();
  };

  if (loading) {
    return <Loader />;
  }

  if (error || !data) {
    return <div className="error">{error}</div>;
  }

  return (
    <div className="addon-info-overlay">
      <AddOnOverlayHeader {...{ onBackClick: handleBackClick }} />
      <AddOnOverlayBody {...{ data, onTncClick }} />
    </div>
  );
};

export default AddOnInfoOverlay;
